import React, { useState, useEffect } from 'react';
import { BarLoader } from 'react-spinner-animated';
import { useNavigate } from 'react-router-dom';

import 'react-spinner-animated/dist/index.css'
import { makeStyles } from '@material-ui/core/styles';

import request from '../utils/request';

const Tabs = () => {
    const navigate = useNavigate();
    const classes = useStyles();

    const [currentTab, setCurrentTab] = useState('1');

    const handleTabClick = (e) => {
        setCurrentTab(e.target.id);
    }

    const [FetchTabs, setOtherTabs] = useState(false);
    useEffect(() => {
        async function fetchData() {
            setOtherTabs(await request.get_Data());
        }
        fetchData();
    }, [FetchTabs]);

    return FetchTabs ? (
        <div className={`container area ${classes.root}`}>
                <ul className="circles">
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            <div className='tabs'>
                {FetchTabs.map((tab, i) =>
                    <button key={i} id={tab.id} disabled={currentTab === `${tab.id}`} onClick={(handleTabClick)}>{tab.Name}</button>
                )}
            </div>
            <div className='content'>
                {FetchTabs.map((tab, i) =>
                    <div key={i}>
                        {currentTab === `${tab.id}` && 
                            <div>
                                <p className='title'>Gradea tu carta con { tab.Name } por Q{ tab.Price * 8 }</p>
                                <p>{tab.Content}</p>
                                <a href={tab.Link} target="_blank">Página Oficial</a>
                                <div className='imgbox'>
                                    <img src={require(`../../img/${tab.Name} grading.png`)} alt='logo' className={classes.imageService} />
                                    <button
                                        className="button-29"
                                        role="button"
                                        onClick={() => {
                                            navigate('/paymentForm?grading=' + tab.Name, { state: { price: tab.Price } });
                                        }} > Comprar </button>
                                </div>
                            </div>}
                    </div>
                )}
            </div>
        </div>
    ) : 
    (
        <BarLoader text={"Gradeando internet"} bgColor={"#0094ff"} width={"150px"} height={"150px"} />
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: 'visible !important',
    },
    imageService: {
        width: '75%',
        height: 'auto',
        maxWidth: '90%',
    },
}));

export default Tabs;